/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_PlanInputs */

const zh_billing_plan = /** @type {(inputs: Billing_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计划`)
};

const en_billing_plan = /** @type {(inputs: Billing_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

const es_billing_plan = /** @type {(inputs: Billing_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan`)
};

/**
* | output |
* | --- |
* | "Plan" |
*
* @param {Billing_PlanInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const billing_plan = /** @type {((inputs?: Billing_PlanInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_PlanInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_billing_plan(inputs)
	if (locale === "en") return en_billing_plan(inputs)
	return es_billing_plan(inputs)
});